import React from 'react';
import { Button, Result } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const PageNotFound: React.FunctionComponent = () => (
  <Result
    icon={<QuestionCircleOutlined />}
    title="404 Page Not Found"
    subTitle="Sorry, that page doesnt exist."
    extra={
      <Link to="/">
        <Button type="primary">Back Home</Button>
      </Link>
    }
  />
);

export default PageNotFound;
